import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'

function AdvertiseCard({ src, title, description }) {
  return (
    <div className={`${styles.advertiseCardBox} d-flex flex-column justify-content-center align-items-center text-center`}>
      <div className={`${styles.icon}`}>
        <MyImage src={src} alt="icon" width="75" height="75" />
      </div>
      <h6 className={`${styles.advertiseTitle} mt-md-3 mt-1 mb-1 fw-bold`}>{title}</h6>
      <p className={`${styles.advertisedesc} mb-0`}>{description}</p>
    </div>
  )
}

AdvertiseCard.propTypes = {
  src: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default AdvertiseCard
